import React, { useContext } from "react";
import { NavContext } from "../context/NavContext";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

// import { iconShadow } from "../animation/animation";

export const NavBarButton = styled(Button)(() => ({
  "&:hover": {
    //animation: `${iconShadow} 0.6s both`
  },
}));

const NavLink = (props: { page: any }) => {
  const { page } = props;

  const { activeNavLinkId, setActiveNavLinkId } = useContext(NavContext);

  const handleClick = () => {
    setActiveNavLinkId(page.menuTitle);
    document!
      .getElementById(page!.pageURL)!
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <NavBarButton
      id={page.menuTitle}
      className={activeNavLinkId === page.menuTitle ? "activeClass" : ""}
      href={page.pageURL}
      color="inherit"
      onClick={handleClick}
    >
      {page.menuTitle}
    </NavBarButton>
  );
};

export default NavLink;
